// creates an object with a key of key
// and a value of value
// if certain conditions are met
export default function objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return (Array.isArray(value) && value.length > 0) ||
        (!Array.isArray(value) && value)
        ? { [key]: value }
        : {};
}
//# sourceMappingURL=object-with-key.js.map